import React from "react";

export const AppleTVPlusIconV2 = ({ width, height }) => {
  return (
    <span>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 27.33 12.47"
        fill="currentColor"
        width={width}
        height={height}
      >
        <path d="m6.23,1.16c.06.6-.18,1.19-.53,1.63-.37.43-.95.76-1.53.71-.08-.58.22-1.19.55-1.56.37-.44,1-.75,1.52-.78Z" />
        <path d="m4.86,3.91c.38-.15.85-.33,1.36-.3.33.02,1.28.12,1.88,1.01,0,0,0,0-.02.01-.16.1-1.1.71-1.09,1.92.01,1.44,1.2,1.98,1.36,2.05.01,0,.02,0,.02,0,0,0,0,0,0,.01-.03.1-.24.75-.7,1.42-.43.62-.87,1.24-1.58,1.25-.33,0-.56-.09-.79-.19-.25-.1-.5-.21-.9-.21s-.69.11-.95.22c-.22.09-.44.18-.74.19-.68.02-1.2-.66-1.63-1.29C.19,8.76-.48,6.47.43,4.92c.44-.77,1.25-1.26,2.12-1.27.38,0,.75.14,1.06.26.24.09.46.18.63.18.16,0,.37-.08.61-.18Z" />
        <path d="m11.63,4.12v-1.69h0s-1.43,0-1.43,0v1.69h-1.06v1.12h1.06v4.13c0,1.37.56,1.91,1.99,1.91.32,0,.65-.03.82-.06v-1.13c-.1.01-.34.03-.5.03-.61,0-.88-.28-.88-.9v-3.99h1.38v-1.12h-1.38Z" />
        <path d="m16.33,11.22h1.52l2.54-7.1h-1.48l-1.79,5.71h-.03l-1.79-5.71h-1.51l2.55,7.1Z" />
        <path d="m23.2,11.22h1.31v-2.91h2.81v-1.28h-2.81v-2.91h-1.31v2.91h-2.81v1.28h2.81v2.91Z" />
      </svg>
    </span>
  );
};

export const AppleTVPlusIcon = ({
  opacity,
  width,
  height,
  fill = "#212121",
  extraClasses = "",
}) => {
  return (
    <span role="img" className={extraClasses}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width || "100%"}
        height={height || "100%"}
        viewBox="0 0 27 10"
        fill="none"
      >
        <g opacity={opacity || 0.4}>
          <path
            d="M6.14183 0C6.20431 0.591873 5.96707 1.17113 5.61717 1.6026C5.2546 2.02196 4.68015 2.35437 4.10518 2.30515C4.03015 1.73814 4.31783 1.13453 4.64263 0.764765C5.00457 0.333165 5.62972 0.0251136 6.14183 0Z"
            fill={fill}
          />
          <path
            d="M4.79234 2.71039C5.16581 2.56535 5.62742 2.38609 6.1353 2.41595C6.45934 2.44056 7.39406 2.539 7.9922 3.41103C7.98918 3.4133 7.98245 3.41765 7.97246 3.4241C7.81783 3.52398 6.88387 4.12726 6.89565 5.31625C6.9073 6.73427 8.08119 7.26573 8.23687 7.33622C8.24714 7.34087 8.25299 7.34351 8.25376 7.34427C8.25311 7.3462 8.25196 7.34985 8.25029 7.35513C8.21981 7.45166 8.01706 8.09385 7.55614 8.7577C7.1325 9.37241 6.69606 9.97476 5.99831 9.987C5.66978 9.99304 5.44814 9.89942 5.21749 9.802C4.97563 9.69985 4.72387 9.59351 4.32858 9.59351C3.91403 9.59351 3.65014 9.70326 3.3964 9.8088C3.17722 9.89995 2.96562 9.98796 2.67102 9.99937C1.99811 10.0236 1.48754 9.3473 1.06377 8.73309C0.191136 7.49154 -0.469227 5.23056 0.427985 3.70608C0.864173 2.94409 1.66191 2.46504 2.52148 2.45268C2.89681 2.44586 3.25601 2.58575 3.56944 2.70782C3.80758 2.80056 4.0193 2.88301 4.19159 2.88301C4.34783 2.88301 4.5518 2.8038 4.79234 2.71039Z"
            fill={fill}
          />
          <path
            d="M11.4533 2.92063V1.25102L11.4534 1.2509H10.0442V2.92051H9.0008V4.02248H10.0442V8.08961C10.0442 9.43855 10.5929 9.97288 12.0021 9.97288C12.3205 9.97288 12.6457 9.94613 12.8083 9.91268V8.80415C12.7133 8.81753 12.4696 8.83759 12.3205 8.83759C11.7244 8.83759 11.4534 8.55706 11.4534 7.94928V4.02235H12.815V2.92063H11.4533Z"
            fill={fill}
          />
          <path
            d="M16.0858 9.91798H17.5812L20.0828 2.92152H18.6213L16.8572 8.54406H16.8234L15.0593 2.92152H13.5707L16.0858 9.91798Z"
            fill={fill}
          />
          <path
            d="M22.8589 9.91798H24.1514V7.05024H26.9232V5.78951H24.1514V2.92152H22.8589V5.78964H20.0869V7.05037H22.8589V9.91798Z"
            fill={fill}
          />
        </g>
      </svg>
    </span>
  );
};
